// extracted by mini-css-extract-plugin
export default {"landingPageContainer":"CmsLandingPage__landingPageContainer__xgPAw"};